module.exports = "<p *ngIf=\"control?.touched\" class=\"validation-control\">\r\n    {{showError(control?.errors)}}\r\n</p>\r\n"